import React, { useState, useEffect } from 'react';
import BookingService from './BookingService';
import Alert from 'react-bootstrap/Alert';
import filterFieldsForList from '../../common/functions/filterFieldsForList';
import schema from './jsonSchema';
import useHeaderGenerator from 'components/app/common/functions/useHeaderGenerator';
import useTableGenerator from '../../common/functions/useTableGenerator';
import { se } from 'date-fns/locale';

const BookingsTable = () => {
  const [columns, setColumns] = useState([]);
  const [error, setError] = useState('');
  const [noDataToShow, setNoDataToShow] = useState(true);
  const [tableGenerated, setTableGenerated] = useState();
  const [refreshList, setRefreshList] = useState(false);


  const deleteBookings = identification => {
    console.log('Deleting booking with identifier:', identification);
    BookingService.deleteBooking(identification)
      .then(response => {
        console.log(response);
        setRefreshList(true);
      })
      .catch(error => console.log(error));
  };

  const jsonSchema = schema;
  const convertDateFromArray = dateArray => {
    const [year, month, day] = dateArray;
    return `${day}/${month}/${year}`;
  };
  useEffect(() => {
    const fieldsForList = filterFieldsForList(jsonSchema);
    const profile = JSON.parse(localStorage.getItem('profile'));
    setColumns(fieldsForList);

    BookingService.retrieveUpcomingBookingsByUser()
      .then(data => {
        const updatedData = data.map(n => {
       
        const time = new Date(n.startTime).toLocaleDateString();
        const date = convertDateFromArray(n.date);
        const isOnWaitlist = n.waitlisted && n.waitlisted.some(w => w.identifier === profile.identifier);
        return { ...n, owner: {firstName:'John', lastName: 'Doe'}, starTime: time, date: date, message: 'safsadsf', class: n.name, 
          status: isOnWaitlist ? 'Waitlisted' : 'Booked' };
      });

        const actionButtons = [
          {
            icon: 'trash-alt',
            onClick: identifier => {
              deleteBookings(identifier);
              setRefreshList(true);
            },
            className: 'p-0',
            title: 'Cancel',
            variant: 'action'
          }
        ];

        setNoDataToShow(updatedData.length === 0);
        setTableGenerated(useTableGenerator(updatedData, jsonSchema, actionButtons));
        setRefreshList(false);
      })
      .catch(error => setError(error.message));
  }, [refreshList]);

  const buttonsConf = [];
  const headerGenerated = useHeaderGenerator('Upcoming Bookings', ' ', buttonsConf);

  return (
    <>
      {error}
      {headerGenerated}
      {noDataToShow && (
        <Alert key="warning" variant="warning">
          There's not any Bookings to show.
        </Alert>
      )}
      {tableGenerated}
    </>
  );
};

export default BookingsTable;